/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workspace_Vertical_StackInputs */



/**
* | output |
* | --- |
* | "Vertical Stack" |
*
* @param {Workspace_Vertical_StackInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const workspace_vertical_stack = /** @type {((inputs?: Workspace_Vertical_StackInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workspace_Vertical_StackInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Empilement vertical")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vertikaler Stapel")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pila verticale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вертикальная стопка")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pila vertical")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("垂直堆叠")
	if (locale === "ja") return /** @type {LocalizedString} */ ("垂直スタック")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वर्टिकल स्टैक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pilha vertical")
	return /** @type {LocalizedString} */ ("Vertical Stack")
});